<template>
  <div>
    <div class="inner-content">
        <h2>{{ $t('term.title') }}</h2>

        <p class="mb30">{{ $t('term.describe') }}</p>
        
        <h3>{{ $t('term.article_1.title') }}</h3>
        <p class="mb10">{{ $t('term.article_1.describe') }}</p>

        <p class="txt-indent mb10">{{ $t('term.article_1.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.2') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.3.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p>{{ $t('term.article_1.3.detail.1') }}</p>
            <p>{{ $t('term.article_1.3.detail.2') }}</p>
        </div>
        <p class="txt-indent mb10">{{ $t('term.article_1.4') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.5') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.6') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.7') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.8') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.9') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_1.10') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_1.11') }}</p>

        <h3>{{ $t('term.article_2.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_2.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_2.2') }}</p>

        <h3>{{ $t('term.article_3.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_3.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_3.2') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_3.3') }}</p>

        <h3>{{ $t('term.article_4.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_4.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_4.2.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p>{{ $t('term.article_4.2.detail.1') }}</p>
            <p>{{ $t('term.article_4.2.detail.2') }}</p>
            <p class="txt-indent">{{ $t('term.article_4.2.detail.3') }}</p>
            <p>{{ $t('term.article_4.2.detail.4') }}</p>
            <p class="txt-indent">{{ $t('term.article_4.2.detail.5') }}</p>
            <p>{{ $t('term.article_4.2.detail.6') }}</p>
            <p>{{ $t('term.article_4.2.detail.7') }}</p>
        </div>
        <p class="txt-indent mb30">{{ $t('term.article_4.3') }}</p>

        <h3>{{ $t('term.article_5.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_5.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_5.2') }}</p>
        
        <h3>{{ $t('term.article_6.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_6.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_6.2') }}</p>
        
        <h3>{{ $t('term.article_7.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_7.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_7.2') }}</p>

        <h3>{{ $t('term.article_8.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_8.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_8.2') }}</p>

        <h3>{{ $t('term.article_9.title') }}</h3>
        <p class="mb30">{{ $t('term.article_9.describe') }}</p>

        <h3>{{ $t('term.article_10.title') }}</h3>
        <p class="mb30">{{ $t('term.article_10.describe') }}</p>

        <h3>{{ $t('term.article_11.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_11.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_11.2') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_11.3.describe') }}</p>
        <div class="txt-paragraph mb30">
            <p>{{ $t('term.article_11.3.detail.1') }}</p>
            <p>{{ $t('term.article_11.3.detail.2') }}</p>
        </div>

        <h3>{{ $t('term.article_12.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_12.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_12.2') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_12.3') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_12.4') }}</p>

        <h3>{{ $t('term.article_13.title') }}</h3>
        <p class="mb10">{{ $t('term.article_13.describe') }}</p>
        <div class="txt-paragraph mb30">
            <p>{{ $t('term.article_13.detail.1') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.2') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.3') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.4') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.5') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.6') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.7') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.8') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.9') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.10') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.11') }}</p>
            <p class="txt-indent">{{ $t('term.article_13.detail.12') }}</p>
        </div>

        <h3>{{ $t('term.article_14.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_14.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_14.2') }}</p>
        
        <h3>{{ $t('term.article_15.title') }}</h3>
        <p class="mb30">{{ $t('term.article_15.describe') }}</p>

        <h3>{{ $t('term.article_16.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_16.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_16.2') }}</p>
        
        <h3>{{ $t('term.article_17.title') }}</h3>
        <p class="mb30">{{ $t('term.article_17.describe') }}</p>

        <h3>{{ $t('term.article_18.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_18.1.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p>{{ $t('term.article_18.1.detail.1') }}</p>
            <p>{{ $t('term.article_18.1.detail.2') }}</p>
            <p>{{ $t('term.article_18.1.detail.3') }}</p>
            <p>{{ $t('term.article_18.1.detail.4') }}</p>
            <p>{{ $t('term.article_18.1.detail.5') }}</p>
        </div>
        <p class="txt-indent mb10">{{ $t('term.article_18.2') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_18.3') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_18.4') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_18.5') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_18.6') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_18.7') }}</p>
        
        <h3>{{ $t('term.article_19.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_19.1.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p>{{ $t('term.article_19.1.detail.1') }}</p>
            <p>{{ $t('term.article_19.1.detail.2') }}</p>
            <p>{{ $t('term.article_19.1.detail.3') }}</p>
            <p class="txt-indent">{{ $t('term.article_19.1.detail.4') }}</p>
            <p>{{ $t('term.article_19.1.detail.5') }}</p>
            <p>{{ $t('term.article_19.1.detail.6') }}</p>
            <p>{{ $t('term.article_19.1.detail.7') }}</p>
        </div>
        <p class="txt-indent mb10">{{ $t('term.article_19.2') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_19.3') }}<br><a href="https://knockonthedoor.jp/privacy/" target="_blank">https://knockonthedoor.jp/privacy/ </a></p>
        
        <h3>{{ $t('term.article_20.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_20.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.2') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.3') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.4') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.5') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.6') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.7') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_20.8') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_20.9') }}</p>
        
        <h3>{{ $t('term.article_21.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_21.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_21.2.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p>{{ $t('term.article_21.2.detail.1') }}</p>
            <p class="txt-indent">{{ $t('term.article_21.2.detail.2') }}</p>
            <p class="txt-indent">{{ $t('term.article_21.2.detail.3') }}</p>
            <p class="txt-indent">{{ $t('term.article_21.2.detail.4') }}</p>
            <p>{{ $t('term.article_21.2.detail.5') }}</p>
            <p>{{ $t('term.article_21.2.detail.6') }}</p>
        </div>
        <p class="txt-indent mb30">{{ $t('term.article_21.3') }}</p>
        
        <h3>{{ $t('term.article_22.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_22.1.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p>{{ $t('term.article_22.1.detail.1') }}</p>
            <p>{{ $t('term.article_22.1.detail.2') }}</p>
            <p>{{ $t('term.article_22.1.detail.3') }}</p>
            <p>{{ $t('term.article_22.1.detail.4') }}</p>
        </div>
        <p class="txt-indent mb30">{{ $t('term.article_22.2') }}</p>

        <h3>{{ $t('term.article_23.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_23.1') }}</p>
        <p class="txt-indent mb10">{{ $t('term.article_23.2.describe') }}</p>
        <div class="txt-paragraph mb30">
            <p class="txt-indent">{{ $t('term.article_23.2.detail.1') }}</p>
            <p>{{ $t('term.article_23.2.detail.2') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.3') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.4') }}</p>
            <p>{{ $t('term.article_23.2.detail.5') }}</p>
            <p>{{ $t('term.article_23.2.detail.6') }}</p>
            <p>{{ $t('term.article_23.2.detail.7') }}</p>
            <p>{{ $t('term.article_23.2.detail.8') }}</p>
            <p>{{ $t('term.article_23.2.detail.9') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.10') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.11') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.12') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.13') }}</p>
            <p class="txt-indent">{{ $t('term.article_23.2.detail.14') }}</p>
            <p>{{ $t('term.article_23.2.detail.15') }}</p>
            <p>{{ $t('term.article_23.2.detail.16') }}</p>
        </div>
        
        <h3>{{ $t('term.article_24.title') }}</h3>
        <p class="mb10">{{ $t('term.article_24.describe') }}</p>
        <div class="txt-paragraph mb30">
            <p class="txt-indent">{{ $t('term.article_24.detail.1') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.2') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.3') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.4') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.5') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.6') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.7') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.8') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.9') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.10') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.11') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.12') }}</p>
            <p class="txt-indent">{{ $t('term.article_24.detail.13') }}</p>
        </div>
        
        <h3>{{ $t('term.article_25.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_25.1.describe') }}</p>
        <div class="txt-paragraph mb10">
            <p class="txt-indent">{{ $t('term.article_25.1.detail.1') }}</p>
            <p class="txt-indent">{{ $t('term.article_25.1.detail.2') }}</p>
            <p class="txt-indent">{{ $t('term.article_25.1.detail.3') }}</p>
            <p class="txt-indent">{{ $t('term.article_25.1.detail.4') }}</p>
        </div>
        <p class="txt-indent mb30">{{ $t('term.article_25.2') }}</p>
        
        <h3>{{ $t('term.article_26.title') }}</h3>
        <p class="mb30">{{ $t('term.article_26.describe') }}</p>
        
        <h3>{{ $t('term.article_27.title') }}</h3>
        <p class="txt-indent mb10">{{ $t('term.article_27.1') }}</p>
        <p class="txt-indent mb30">{{ $t('term.article_27.2') }}</p>

        <h3>{{ $t('term.article_28.title') }}</h3>
        <p class="mb50">{{ $t('term.article_28.describe') }}</p>
        
        <p class="right">{{ $t('term.end') }}</p>
    </div>
    <!-- /.inner-content -->
  </div>
</template>

<script>
  export default {
    mounted() {
        this.screenTracking(this.$t('terms_of_service'))
        if(navigator.userAgent.indexOf("Win") != -1 && this.$t('__locale') === 'en') {
            document.getElementsByClassName('inner-content')[0].classList.add('inner-content-vi')
        }
    }
  }
</script>
<style scoped>
    h2, h3 {
        font-weight: bold !important;
    }
    .inner-content-vi {
        font-family: "Arial", Georgia, serif;
    }
    .inner-content-vi h2 {
        font-size: 1.6rem !important;
    }
    .inner-content-vi h3{
        font-size: 1.5rem !important;
    }
    .inner-content-vi p{
        font-size: 1.3rem !important;
    }
</style>
